export default {
  login: {
    title: 'Iniciar Sesión',
    username: 'Nombre de Usuario',
    phone: 'Número de Teléfono',
    phoneCode: 'Código',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    captcha: 'Captcha',
    loading: 'Cargando...',
    rememberMe: 'Recuérdame',
    forgotPassword: '¿Has olvidado tu contraseña?',
    loginButton: 'Iniciar Sesión',
    contactUs: '¿Contacta con nosotros？',
    noAccount: '¿No tienes cuenta?',
    registerNow: 'Registrarse',
    or: 'O',
    orSignInWith: 'O inicia sesión con',
    methodUsername: 'Nombre de usuario',
    methodPhone: 'Teléfono',
    methodEmail: 'Correo',
    usernameRequired: 'El nombre de usuario es obligatorio',
    phoneRequired: 'El número de teléfono es obligatorio',
    emailRequired: 'El correo electrónico es obligatorio',
    passwordRequired: 'La contraseña es obligatoria',
    captchaRequired: 'El captcha es obligatorio',
    resetPassword: 'Restablecer Contraseña',
    resetStep1Hint: 'Introduce tu número de teléfono o correo electrónico para recibir un código de verificación.',
    useEmailInstead: 'Usar correo electrónico',
    usePhoneInstead: 'Usar teléfono',
    sendCode: 'Enviar Código',
    resetStep2Hint: 'Se ha enviado un código de verificación a',
    verificationCode: 'Código de Verificación',
    verificationCodeRequired: 'El código de verificación es obligatorio',
    resendIn: 'Reenviar en',
    resendCode: 'Reenviar Código',
    verify: 'Verificar',
    resetStep3Hint: 'Establece tu nueva contraseña.',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
    confirmPasswordRequired: 'Por favor confirma tu contraseña',
    passwordMismatch: 'Las contraseñas no coinciden',
    resetPasswordBtn: 'Restablecer Contraseña',
    back: 'Atrás',
    // Format validation
    emailFormat: 'Formato de correo inválido',
    // Toast messages
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Inicio de sesión fallido',
    signInWithGoogle: 'Iniciar sesión con Google+',
    codeSent: 'Código de verificación enviado',
    sendCodeFailed: 'Error al enviar el código',
    invalidCode: 'Código de verificación inválido',
    resetSuccess: 'Contraseña restablecida correctamente',
    resetFailed: 'Error al restablecer la contraseña'
  }
};
